import { Component } from '@angular/core';
import { BeesFooterComponent } from '../bees-footer/bees-footer.component';
import { BeesHeaderComponent } from '../bees-header/bees-header.component';

@Component({
  selector: 'app-arbitration-mediation',
  standalone: true,
  imports: [BeesFooterComponent, BeesHeaderComponent],
  templateUrl: './arbitration-mediation.component.html',
  styleUrl: './arbitration-mediation.component.scss'
})
export class ArbitrationMediationComponent {

}
